"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveUpdatePanel = void 0;
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
const Flex_1 = __importDefault(require("./Flex"));
exports.LiveUpdatePanel = (0, styled_components_1.styled)(Flex_1.default) `
  background: ${(props) => props.isHidden ? "" : props.theme.button.bg.normal};
  border-radius: ${({ theme }) => theme.radius};
  align-items: center;
  min-width: 300px;
`;
//# sourceMappingURL=LiveUpdatePanel.js.map